<div class="xr-auth-stack">
  <span class="xr-auth-badge" aria-hidden="true">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16v12H4z"/><path d="m4 7 8 6 8-6"/></svg>
  </span>
  <div>
    <h1 class="xr-auth-title">{{ "recovery_password.check_mail_title" | translate }}</h1>
    <p class="xr-auth-subtitle">{{ "recovery_password.sent_recovery_password" | translate }}</p>
  </div>
  <a [routerLink]="['/login']" class="xr-btn xr-btn--secondary xr-auth-submit">
    {{ "recovery_password.back_login" | translate }}
  </a>
</div>
